import {
  IMPACT_REPORT_MASTHEAD_LABEL,
  IMPACT_REPORT_MASTHEAD_LOGO_ALT,
} from "@/constants/impactReport";

interface ImpactReportPdfCoverProps {
  /**
   * The GfG mark, as a `data:` URI. It must be the LIGHT mark (`assets.brand.gfgMark`): the cover
   * prints on a dark ground and print styles apply no filter to recolour it.
   */
  logoSrc: string;
  /** The wire's `orgName`. `""` is the wire's explicitly-absent value, and prints no line at all. */
  orgName: string;
  /** The matched date range, already formatted exactly as the masthead formats it. */
  dateRangeLabel: string;
}

/**
 * The PDF's front cover: the sheet the serialised document prints ahead of the hero pages, in
 * place of the on-screen masthead strip. Never rendered on screen.
 *
 * Always plain — the dark brand ground, no photograph — matching the back cover, because
 * Crunchy's one default image repeated across cover, summary and thank-you pages otherwise.
 *
 * Props only, with no hook and no context, because it is rendered by `renderToStaticMarkup` with
 * no provider mounted. Every string it prints is the masthead's own copy.
 */
export function ImpactReportPdfCover({
  logoSrc,
  orgName,
  dateRangeLabel,
}: ImpactReportPdfCoverProps) {
  return (
    <section className="irv-pdf-cover">
      <div className="irv-pdf-cover-inner">
        <img className="irv-pdf-cover-logo" src={logoSrc} alt={IMPACT_REPORT_MASTHEAD_LOGO_ALT} />
        <div className="irv-title">{IMPACT_REPORT_MASTHEAD_LABEL}</div>
        {orgName !== "" && <div className="irv-pdf-cover-org">{orgName}</div>}
        <div className="irv-kicker irv-pdf-cover-dates">{dateRangeLabel}</div>
      </div>
    </section>
  );
}
